import { render, staticRenderFns } from "./ProductSwiper.vue?vue&type=template&id=e3f756be&"
import script from "./ProductSwiper.vue?vue&type=script&lang=js&"
export * from "./ProductSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports